import { lazy } from "react";

export const SuperAdminDashboardPage = lazy(() =>
  import("../../pages/superadmin/dashboard").then((m) => ({
    default: m.SuperAdminDashboardPage,
  })),
);

export const OrganizationDashboardPage = lazy(() =>
  import("../../pages/organizations/dashboard").then((m) => ({
    default: m.OrganizationDashboardPage,
  })),
);

export const OrganizationListPage = lazy(() =>
  import("../../pages/superadmin/organization-list").then((m) => ({
    default: m.OrganizationListPage,
  })),
);

export const CreateOrganizationPage = lazy(() =>
  import("../../pages").then((m) => ({ default: m.CreateOrganizationPage })),
);

export const UpdateOrganizationPage = lazy(() =>
  import("../../pages").then((m) => ({ default: m.UpdateOrganizationPage })),
);

export const CitiesPage = lazy(() =>
  import("../../pages").then((m) => ({ default: m.CitiesPage })),
);

export const CampaignPage = lazy(() =>
  import("../../pages/CampaignPage").then((m) => ({
    default: m.CampaingnPage,
  })),
);

export const CampaignAddEditPage = lazy(() =>
  import("../../pages/CampaignPage").then((module) => ({
    default: module.AddEditCampaignPage,
  })),
);

export const AddEditNGOPage = lazy(() =>
  import("../../pages/AddEditNGOPage").then((m) => ({
    default: m.AddEditNGOPage,
  })),
);

export const OrganizationCitiesPage = lazy(() =>
  import("../../pages").then((m) => ({ default: m.OrganizationCitiesPage })),
);

export const OrganizationSettingsPage = lazy(() =>
  import("../../pages").then((m) => ({ default: m.OrganizationSettingsPage })),
);

export const SettingPage = lazy(() =>
  import("../../pages/SettingPage/SettingPage").then((m) => ({
    default: m.default,
  })),
);

export const UserSettingPage = lazy(() =>
  import("../../pages/UserSettingPage/UserSettingPage").then((m) => ({
    default: m.default,
  })),
);

export const NGOsTablePage = lazy(() =>
  import("../../pages").then((m) => ({ default: m.NGOsTablePage })),
);

// Superadmin version
export const NGOsTablePageAdmin = lazy(() =>
  Promise.resolve({ default: () => <NGOsTablePage mode="admin" /> }),
);

export const NGOsTablePageOrg = lazy(() =>
  Promise.resolve({ default: () => <NGOsTablePage mode="organization" /> }),
);

export const ResetPasswordPage = lazy(() =>
  import("../../pages/organizations/reset-password").then((m) => ({
    default: m.ResetPasswordPage,
  })),
);

export const CategoriesPage = lazy(() =>
  import("../../pages/superadmin/categories").then((m) => ({
    default: m.CategoriesPage,
  })),
);

export const MemberPage = lazy(() =>
  import("../../pages/MemberPage").then((m) => ({
    default: m.MemberPage,
  })),
);

export const AddEditMemberPage = lazy(() =>
  import("../../pages/MemberPage/index").then((m) => ({
    default: m.AddEditMemberPage,
  })),
);

export const NgoDashboard = lazy(() =>
  import("../../pages/ngo/dashboard").then((m) => ({
    default: m.NgoDashboard,
  })),
);

export const MyDonationPage = lazy(() =>
  import("../../pages/donor/my-donation/MyDonation").then((m) => ({
    default: m.default,
  })),
);

export const ProjectList = lazy(() =>
  import("../../pages/ProjectsPage").then((m) => ({
    default: m.ProjectListPage,
  })),
);

export const donationsPage = lazy(() =>
  import("../../pages/DonationsPage/").then((m) => ({
    default: m.DonationsPage,
  })),
);

export const donationsFollowUpPage = lazy(() =>
  import("../../pages/DonationManagementPage").then((m) => ({
    default: m.DonationManagementPage,
  })),
);

export const addDonationsPage = lazy(() =>
  import("../../pages/DonationsPage/components/AddDonationPage/DonationForm/DonationForm").then(
    (m) => ({
      default: m.default,
    }),
  ),
);

export const organizationMemberPage = lazy(() =>
  import("../../pages/OrganizationUserPage").then((m) => ({
    default: m.OrganizationUserPage,
  })),
);

//report page
export const reportPage = lazy(() =>
  import("../../pages/ReportPage/ReportPage").then((m) => ({
    default: m.default,
  })),
);
